<template>
  <div>
    <!-- <cm-transaction-popup></cm-transaction-popup> -->
    <cm-transaction-popup></cm-transaction-popup>
    <!-- <cm-transaction-edit-popup></cm-transaction-edit-popup> -->
  </div>
</template>

<script>
import TransactionPopup from './CMPayments.vue'
import DebtorListPopup from './CMDebtorList.vue'

// import TransactionEditPopup from './CMTransactionEdit.vue'

export default {
  name: 'cm-service-popups',
  components: {
    'cm-transaction-popup': TransactionPopup,
    'cm-debtorList-popup': DebtorListPopup
    // 'cm-transaction-edit-popup': TransactionEditPopup
  }
}
</script>
